import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SelectFieldComponent } from '@shared/components/form-elements/select-field/select-field.component';
import { TranslateModule } from '@ngx-translate/core';
import { CalendarFieldComponent } from '@shared/components/form-elements/calendar-field/calendar-field.component';
import { MultiSelectFieldComponent } from '@shared/components/form-elements/multi-select-field/multi-select-field.component';

@Component({
  selector: 'order-filter',
  imports: [
    CommonModule,
    RouterModule,
    SelectFieldComponent,
    TranslateModule,
    CalendarFieldComponent,
    MultiSelectFieldComponent,
  ],
  templateUrl: './order-filter.component.html',
  styleUrls: ['./order-filter.component.scss'],
})
export class OrderFilterComponent {}
